module.exports = __webpack_public_path__ + "assets/img/home_icon.b66983ba.svg";